module.exports = __webpack_public_path__ + "img/landingpage_2023@2x.c315e430.png";